/**
 * Remitter types for Canadian payroll tax remittance
 * Determines how frequently employers must remit payroll source deductions to the CRA
 */
export const ERemitterType = {
  QUARTERLY: "quarterly",
  REGULAR: "regular",
  ACCELERATED_THRESHOLD_1: "accelerated_threshold_1",
  ACCELERATED_THRESHOLD_2: "accelerated_threshold_2",
} as const;

export type ERemitterType = (typeof ERemitterType)[keyof typeof ERemitterType];
